import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormulaireService } from '../../services/public/formulaire.service';
import {BsModalRef, ModalOptions} from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { AlertesService } from '../../services/public/alertes.service';

@Component({
  selector: 'app-add-piece-publicdemande',
  templateUrl: './add-piece-publicdemande.component.html',
  styleUrls: ['add-piece-publicdemande.component.scss']
})
export class AddPiecePublicdemandeComponent implements OnInit {
  titre = "COMPLEMENT";
  fields_form: any[] = [];
  field_type: any[] = [];
  formName: string = '';
  show_options = false;
  OPERATION_REF = null

  constructor(
    private ngxService: NgxUiLoaderService,
    public options: ModalOptions,
    private formulaireService: FormulaireService,
    private alerte: AlertesService,
    private bsmodalRef: BsModalRef
  ) {
    this.OPERATION_REF = options.initialState.operation_ref
  }

  ngOnInit(): void {
    this.getEntriesType();  // Récupérer les types de champs depuis l'API
  }

  getEntriesType() {
    this.ngxService.startLoader('complements_pieces');
    this.formulaireService.getEntriesType().subscribe((res: any) => {
      this.field_type = res;
      this.ngxService.stopLoader('complements_pieces');
    }, (error) => {
      this.ngxService.stopLoader('complements_pieces');
      console.error('Erreur de récupération des types de champs', error);
    });
  }

  // Ajouter un champ au formulaire
  addField() {
    const newField = {
      name: '',
      type: ''
    };

    // Si le champ est de type 'ET-5', ajouter la propriété 'options'
    if (newField.type === 'ET-5') {
      newField['options'] = [];
    }

    this.fields_form.push(newField);
  }


  // Supprimer un champ
  deleteField(index: number) {
    this.fields_form.splice(index, 1);
  }

  // Vérifie et récupère les options si le champ est de type 'ET-5'
  getOptions(field: any, index: number) {
    if (field.type === 'ET-5' && field.optionsInput) {
      field.options = field.optionsInput.split(';').map(option => option.trim());  // Transforme la chaîne en tableau
    }
  }

  closeWithMessage(message: string) {
    this.bsmodalRef.hide();
    this.bsmodalRef.onHidden.emit(message); 
  }

  // Soumettre le formulaire
  onSubmit(form: NgForm) {
    this.ngxService.startLoader('complements_pieces')
    if (form.valid) {
      let body_content = {
        name: this.formName,
        entries: this.fields_form.map(field => {
          if (field.type === 'ET-5') {
            field.options = field.optionsInput.split(';').map(option => option.trim()); // S'assurer que les options sont ajoutées
          }
          return field;
        })
      }

      console.log('Formulaire soumis:', body_content);
      console.log('this.OPERATION_REF :', this.OPERATION_REF);


      let form_to_send = {
        "operation_ref": this.OPERATION_REF
      }
      let complement_form:any = {}
      complement_form["name"] =body_content["name"]
      complement_form["entries"] =[]
      for (let entry of body_content["entries"]){
        if(entry['options']){
          complement_form["entries"].push({"ref":entry['type'], "name":entry['name'],"datasources":entry['options']})
        }else {
          complement_form["entries"].push({"ref":entry['type'], "name":entry['name']})
        }

      }

      form_to_send["complement_form"] = complement_form
      console.log('form_to_send :', form_to_send);

      this.formulaireService.createFormForComplement(form_to_send).subscribe((res:any) =>{ 
        this.alerte.successNotification('Complément', 'Demande de complément effectuée ');
        this.ngxService.stopLoader('complements_pieces')
        this.closeWithMessage('for_open')
      }, error => {
        console.log(error)
        this.ngxService.stopLoader('complements_pieces')
        this.alerte.errorNotification('Complement', error.error.message);
      })
    } else {
      this.alerte.warningNotification('Formulaire', 'Veuillez remplir les champs obligatoires');
      console.log('Le formulaire n\'est pas valide');
      this.ngxService.stopLoader('complements_pieces')
    }
  }

  closeModal() {
    this.bsmodalRef.hide();
  }
}
